module.exports = __webpack_public_path__ + "img/31.93aba752.jpg";